import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

interface Props {
  data: string
  size?: number
  margin?: number
  alt?: string
  className?: string
}

/**
 * Локально-генерируемый QR через canvas → data URL.
 * Преимущества vs api.qrserver.com:
 *   - мгновенно (нет HTTP-roundtrip)
 *   - работает offline
 *   - не зависит от стороннего сервиса
 */
export default function LocalQR({ data, size = 200, margin = 2, alt = 'QR', className = '' }: Props) {
  const [src, setSrc] = useState<string>('')

  useEffect(() => {
    if (!data) { setSrc(''); return }
    let cancelled = false
    QRCode.toDataURL(data, {
      width: size,
      margin,
      errorCorrectionLevel: 'M',
      color: { dark: '#000000', light: '#ffffff' },
    }).then(url => {
      if (!cancelled) setSrc(url)
    }).catch(() => {
      if (!cancelled) setSrc('')
    })
    return () => { cancelled = true }
  }, [data, size, margin])

  if (!src) {
    return (
      <div
        className={`flex items-center justify-center bg-zinc-100 text-zinc-400 text-xs ${className}`}
        style={{ width: size, height: size }}
      >
        …
      </div>
    )
  }
  return <img src={src} alt={alt} width={size} height={size} className={className} />
}
